var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tg-news-card-page-item',{attrs:{"typeid":_vm.typeid,"cardData":_vm.cardData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }